import { Environment } from './environment.model';

export const environment: Environment = {
  apiUrl: 'https://api-dev.petmatcher.com/api',
  production: false,
  environmentName: 'development',
  auth0Domain: 'ppg-ecosystem-test.uk.auth0.com',
  auth0ClientId: '7cenuxodsKxrZF1lJhI9bn6dK1qyBaTx',
  canonicalUrl: 'https://dev.petmatcher.com',
  petDatabaseAppUrl: 'https://petdatabase-dev.azurewebsites.net',
  segmentWriteKey: 'pBZ4SyJLcGjP5bA2u2fkOHBYuhgsSfhs',
  sentryDsn: '',
  featureFlags: {
    clientKey: 'client-KdUQ3lAFRHMw92YPd65xt13MKlWM6QJbc3dHXrxLMo6',
    environment: 'development',
  },
  sanity: {
    projectId: '7mzjz7ut',
    dataset: 'dev-test',
  },
};
